// extracted by mini-css-extract-plugin
export var founder_text = "index-module--founder_text--E4TFK";
export var play_icon = "index-module--play_icon--X+NjK";
export var video_container = "index-module--video_container--jv+1p";
export var video_grid = "index-module--video_grid--rdWgd";
export var video_wrapper = "index-module--video_wrapper--SGmVH";
export var youtube_video_wrapper = "index-module--youtube_video_wrapper--ZJqoZ";